import { HeaderCell as RsuiteHeaderCell } from "rsuite-table";
import PropTypes from "prop-types";

const HeaderCell = ({ children = null, ...props }) => {
  return <RsuiteHeaderCell {...props}>{children}</RsuiteHeaderCell>;
};

HeaderCell.propTypes = {
  children: PropTypes.node,
};

export default HeaderCell;
